import { useState, useEffect } from 'react';
import { onboardingAPI, OnboardingItem } from '../utils/api';

export const useOnboarding = (languageCode?: string) => {
    const [items, setItems] = useState<OnboardingItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchOnboardingItems = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await onboardingAPI.getActiveItems(languageCode);
                // L'API retourne {data: [...]} donc on extrait la propriété data
                setItems(Array.isArray(data) ? data : (data as any)?.data || []);
            } catch (err) {
                setError('Failed to load onboarding items');
                console.error('Error fetching onboarding items:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchOnboardingItems();
    }, [languageCode]);

    return { items, loading, error };
};